export default "__VITE_ASSET__CQG$Msf6__"